import { createSelector } from 'reselect';

const getIsLoadingHelper = (state) => state.loading?.isLoading;

export const getIsLoading = createSelector(
    [ getIsLoadingHelper ],
    ( isLoading ) => ( isLoading)
);
